import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    font-family: ${({ theme }) => theme.fonts.body};
    background-color: ${({ theme }) => theme.colors.body};
  }

  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
    line-height: normal;
  }


  .Toastify__toast {
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.secondary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    padding-block: 0;
    min-height: 55px;
    line-break: auto;
    background-color: ${({ theme }) => theme.colors.primaryLight};

    svg {
      min-width: auto;
    }

    &.Toastify__toast--error {
      background-color: ${({ theme }) => theme.colors.dangerLight};
      border-color: ${({ theme }) => theme.colors.danger};
    }

    &.Toastify__toast--success {
      background-color: ${({ theme }) => theme.colors.successLight};
      border-color: ${({ theme }) => theme.colors.success};
    }
  }
`;

export default GlobalStyles;
